import { sanitizeBranchName } from './sanitizeBranchName';

export const IS_DEV = window.location.hostname.includes('localhost');
export const IS_PREVIEW =
  window.location.hostname.includes('teacher-feedback') ||
  window.location.hostname.includes('preview');
export const IS_PROD = !IS_DEV && !IS_PREVIEW && window.location.hostname.includes('diffit.me');
export const IS_LOCAL = window.location.hostname.includes('localhost');

export const getScreenSize = () => {
  if (typeof window === 'undefined') {
    return 'lg';
  }
  if (window.innerWidth < 640) {
    return 'sm';
  } else if (window.innerWidth < 768) {
    return 'md';
  } else if (window.innerWidth < 1024) {
    return 'lg';
  } else if (window.innerWidth < 1280) {
    return 'xl';
  } else {
    return '2xl';
  }
};

export const attemptToPrint = () => {
  try {
    // This is to account for Safari, who doesn't support a straight window.print()
    if (!document.execCommand('print', false, null)) {
      window.print();
    }
  } catch {
    window.print();
  }
};

// Module-level cache variables
let cachedApiBaseUrl = import.meta.env.VITE_API_BASE_URL; // Start with the default
let lastCheckTimestamp = 0;
const cacheDuration = 5 * 60 * 1000; // 5 minutes in milliseconds

// Async function to check for and update the preview API URL
const updatePreviewApiUrl = async () => {
  const branchRef =
    typeof __VITE_VERCEL_COMMIT_REF__ !== 'undefined' ? __VITE_VERCEL_COMMIT_REF__ : '';
  // Skip PR backend check for main branch (e.g. teacher-feedback.diffit.me CI environment)
  if (!branchRef || branchRef === 'main' || branchRef === 'master') {
    lastCheckTimestamp = Date.now();
    return;
  }
  const sanitizedBranchName = sanitizeBranchName(branchRef);
  const backendURL = `https://api-${sanitizedBranchName}.pr-envs.diffit.me`;
  try {
    // Use { cache: 'no-store' } to prevent browser caching of the health check itself
    const response = await fetch(backendURL + '/health', { cache: 'no-store' });
    if (response.ok) {
      console.log(`Preview backend found for branch ${sanitizedBranchName}. Using: ${backendURL}`);
      cachedApiBaseUrl = backendURL; // Update cache only on success
    } else {
      // If check fails, we keep the default URL in the cache
      console.log(
        `Preview backend health check failed for ${sanitizedBranchName}. Status: ${response.status}. Falling back to default.`
      );
      cachedApiBaseUrl = import.meta.env.VITE_API_BASE_URL; // Explicitly set back to default
    }
    lastCheckTimestamp = Date.now();
  } catch (error) {
    // If fetch fails, keep the default URL in the cache
    console.error(`Error checking preview backend health for ${sanitizedBranchName}:`, error);
    cachedApiBaseUrl = import.meta.env.VITE_API_BASE_URL; // Explicitly set back to default
  }
};

export const getAPIBaseURL = async () => {
  const now = Date.now();

  // For preview environments, check if the cache is stale and trigger an async update if needed
  if (IS_PREVIEW && now - lastCheckTimestamp > cacheDuration) {
    // Trigger the check, but don't wait for it (fire and forget)
    await updatePreviewApiUrl();
  }

  // Always return the currently cached URL (which might be the default or the specific preview URL)
  return cachedApiBaseUrl;
};
